import { layerClass } from "@freightsimple/ui-core/Theme/layers";
import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";

// QuotesProgress palette (from the old Cargo Colors): the circle takes a stroke
// class, the connecting line a background class.
const gray = { circle: "stroke-muted", line: "bg-muted" };
const gold = { circle: "stroke-gold", line: "bg-gold" };
const blue = { circle: "stroke-brand", line: "bg-brand" };
const green = { circle: "stroke-dark-green", line: "bg-dark-green" };

type SegmentPalette = typeof gray;

function CirclePart_({ colorClass }: { colorClass: string }) {
  return (
    <div className={layerClass.raised}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <circle
          className={colorClass}
          cx="15"
          cy="15"
          r="12"
          fill="none"
          strokeWidth="6"
        />
      </svg>
    </div>
  );
}

// The negative margins tuck the line ends under the circles so the strokes
// appear connected.
function LinePart_({ colorClass }: { colorClass: string }) {
  return <div className={`relative -mx-[5px] h-[10px] w-full ${colorClass}`} />;
}

interface ProgressProps {
  shipmentState: ShipmentState;
  twoColumns?: boolean | undefined;
}

// Circle colours for [pickup, transit, delivery] and line colours for the two
// connectors between them.
function paletteForState(shipmentState: ShipmentState): {
  circles: [SegmentPalette, SegmentPalette, SegmentPalette];
  lines: [SegmentPalette, SegmentPalette];
} {
  switch (shipmentState) {
    case ShipmentState.Quoted:
    case ShipmentState.QuoteRequested:
    case ShipmentState.Cancelled:
    case ShipmentState.OnHold:
    case ShipmentState.Lost:
      return { circles: [gray, gray, gray], lines: [gray, gray] };
    case ShipmentState.BookingRequested:
    case ShipmentState.BookingConfirmed:
    case ShipmentState.BookingFailed:
      return { circles: [gold, gray, gray], lines: [gray, gray] };
    case ShipmentState.InTransit:
      return { circles: [blue, blue, gray], lines: [blue, gray] };
    case ShipmentState.Delivered:
      return { circles: [green, green, green], lines: [green, green] };
  }
}

function QuotesProgress(props: ProgressProps) {
  const { circles, lines } = paletteForState(props.shipmentState);
  const columnWidthClass = props.twoColumns ? "w-1/2" : "w-[33%]";

  return (
    <div className="flex w-full flex-row items-center">
      <div className={columnWidthClass}>
        <div className="flex flex-row items-center">
          <CirclePart_ colorClass={circles[0].circle} />
          <LinePart_ colorClass={lines[0].line} />
        </div>
      </div>
      <div className={columnWidthClass}>
        <div className="flex flex-row items-center">
          <CirclePart_ colorClass={circles[1].circle} />
          {!props.twoColumns && <LinePart_ colorClass={lines[1].line} />}
        </div>
      </div>
      {!props.twoColumns && (
        <div className="w-[33%]">
          <CirclePart_ colorClass={circles[2].circle} />
        </div>
      )}
    </div>
  );
}
export default QuotesProgress;
